.dq{color:var(--brand-primary);}